module.exports = __webpack_public_path__ + "klue-logo-email-e2fa5a8a60ed97c32b3aa1e19d0649c4.png";